import { memo } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { BsCheckAll } from "react-icons/bs";

const SelectAll = ({
  id = "btn-select-all",
  title,
  icon = <BsCheckAll className="text-xl" />,
  type = "primary",
  onClick = () => {},
  className,
  ...props
}) => {
  const { t } = useTranslation();
  const btnTitle = title ? title : t("button.select_all");
  return (
    <Button
      className={`flex items-center justify-center bg-green1 hover:opacity-70 ${className}`}
      id={id}
      type={type}
      icon={icon}
      onClick={onClick}
      {...props}
    >
      {btnTitle}
    </Button>
  );
};

export default memo(SelectAll);
